import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Block } from "../../../hoc/Block";
import styles from "./DropdownRadioMultiSelect.module.css";

const DropdownRadioMultiSelect = ({
  data,
  listId,
  emptyListMessage,
  children,
  changed,
}) => {
  const [isListVisible, setIsListVisible] = useState(false);
  const [selectedValues, setSelectedValues] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if (data.length > 0) {
        // if (selectedItems.length === 0) {
          let items = [];
          for (const el of data) {
            if (el.value === true || el.value === false) {
              if (el.shortName) {
                items.push(el.shortName);
              } else {
                items.push(el.label);
              }
            }
          }
          setSelectedItems(items);
          setSelectedValues(items.join(", "));
        // }
      }
    }

    return () => {
      mounted = false;
    };
  }, [data]);

  const changeVisibility = () => {
    if (isListVisible === false) setIsListVisible(true);
    else setIsListVisible(false);
  };

  const onChange = function (listId, name, value) {
    let newItems = [...selectedItems];
    // if shortName property is available, the component uses that instead of the label
    let label = data.filter((item) => item.name === name)[0].shortName;
    if (!label) {
      label = data.filter((item) => item.name === name)[0].label;
    }

    if (!newItems.includes(label)) {
      newItems.push(label);
    }

    setSelectedItems(newItems);
    setSelectedValues(newItems.join(", "));
    changed(listId, name, value);
  };
  return (
    <div className="w-100">
      <div
        className={`${styles.backdrop} ${
          isListVisible ? "visible" : "invisible"
        }`}
        onClick={changeVisibility}
      ></div>
      {children && (
        <Row>
          <label className="fst-italic">{children}</label>
        </Row>
      )}
      <Row>
        <div id="list1" className={`${styles.DropdownRadioMultiSelect} smallItalic`}>
          <span
            className={`${styles.anchor} ${
              selectedValues === "" ? styles.redStyle : ""
            } w-100 nexiColor overflow-hidden`}
            onClick={changeVisibility}
          >
            {selectedValues != "" ? selectedValues : emptyListMessage}
          </span>
          <ul
            className={`${styles.items} ${
              isListVisible ? "visible" : "invisible"
            } overflow-visible`}
          >
            <li key={listId + "-list-header"} className={styles.listHeader}>
              <Row>
                <Col xs={8}></Col>
                <Col xs={2}>Yes</Col>
                <Col xs={2}>No</Col>
              </Row>
            </li>
            {data.map((el, index) => {
              return (
                <li key={listId + "-" + el.name}>
                  {" "}
                  {/* onChange={onChange} */}
                  <Row>
                    <Col xs={8}>
                      <label htmlFor={el.label} className="w-100 text-start">{el.label} </label>
                    </Col>
                    <Col xs={2}>
                      <input
                        type="radio"
                        name={`${el.name}-${listId}`}
                        value={true}
                        checked={el.value !== null ? el.value : false}
                        onChange={() => {
                          onChange(listId, el.name, true);
                        }}
                      />
                    </Col>
                    <Col xs={2}>
                      <input
                        type="radio"
                        name={`${el.name}-${listId}`}
                        value={false}
                        checked={el.value !== null ? !el.value : false}
                        onChange={() => {
                          onChange(listId, el.name, false);
                        }}
                      />
                    </Col>
                  </Row>
                </li>
              );
            })}
          </ul>
        </div>
      </Row>
    </div>
  );
};

export default DropdownRadioMultiSelect;
